import { useState } from "react";
import { useSeoMeta } from "@unhead/react";
import { Link } from "react-router-dom";
import { ArrowLeft, BookMarked, Search } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { GLOSSARY } from "@/lib/resources";

export default function GlossaryPage() {
  const [query, setQuery] = useState("");

  useSeoMeta({
    title: "Glossary — BCH School",
    description:
      "Plain-language definitions of Bitcoin Cash terms for beginners.",
  });

  const q = query.trim().toLowerCase();
  const terms = q
    ? GLOSSARY.filter(
        (t) =>
          t.term.toLowerCase().includes(q) ||
          t.definition.toLowerCase().includes(q),
      )
    : GLOSSARY;

  return (
    <Layout>
      <Button asChild variant="ghost" size="sm" className="mb-4 -ml-2">
        <Link to="/">
          <ArrowLeft className="mr-1 h-4 w-4" /> Home
        </Link>
      </Button>

      <div className="mb-6 flex items-start gap-4">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-3xl bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-sm">
          <BookMarked className="h-7 w-7" />
        </span>
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight">Glossary</h1>
          <p className="mt-1 text-muted-foreground">
            New words explained simply. No jargon, no prior knowledge needed.
          </p>
        </div>
      </div>

      <div className="relative mb-6">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          className="pl-9"
          placeholder="Search terms…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          aria-label="Search glossary"
        />
      </div>

      {terms.length === 0 ? (
        <Card className="border-dashed">
          <CardContent className="py-12 text-center text-muted-foreground">
            No terms match “{query}”. Try a different word.
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-3 sm:grid-cols-2">
          {terms.map((t) => (
            <Card key={t.term} className="border-2">
              <CardContent className="p-5">
                <h2 className="font-bold text-primary">{t.term}</h2>
                <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                  {t.definition}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </Layout>
  );
}
